import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";
import Register from "../auth/Register";
import Login from "../auth/Login";
import NotFound from "../layout/NotFound";
import PrivateRoute from "../routing/PrivateRoute";
import Landing from "../layout/Landing";

// Loaded on demand so the home page doesn't download their code (and
// moment) before it can paint.
// Login/Register stay eager: Navbar imports them for its modals anyway.
const FileUpload = lazy(() => import("../file/FileUpload"));
const RefundContact = lazy(() => import("../refund/RefundContact"));
const TemplateList = lazy(() => import("../template/TemplateList"));
const TemplateForm = lazy(() => import("../template/TemplateForm"));
const PhotoPrint = lazy(() => import("../photo/PhotoPrint"));
const IdPhoto = lazy(() => import("../photo/IdPhoto"));
const Advertise = lazy(() => import("../ads/Advertise"));
const PartnerHub = lazy(() => import("../partner/PartnerHub"));
const PlaceKiosk = lazy(() => import("../partner/PlaceKiosk"));
const BuyKiosk = lazy(() => import("../partner/BuyKiosk"));
const Bundles = lazy(() => import("../bundle/Bundles"));
const MyBundles = lazy(() => import("../bundle/MyBundles"));
const Join = lazy(() => import("../bundle/Join"));
const Stories = lazy(() => import("../story/Stories"));

// Keep CLIENT_ROUTES in server.js in step: other paths get a 404 status.

const Routes = () => {
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route exact path="/" component={Landing} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/register" component={Register} />
        <PrivateRoute exact path="/upload" component={FileUpload} />
        <Route exact path="/refund" component={RefundContact} />
        {/* One path segment each: components load images by relative paths (assets/img/...) */}
        <Route exact path="/templates" component={TemplateList} />
        <Route exact path="/template" component={TemplateForm} />
        <Route exact path="/photo" component={PhotoPrint} />
        <Route exact path="/idphoto" component={IdPhoto} />
        <Route exact path="/advertise" component={Advertise} />
        <Route exact path="/partners" component={PartnerHub} />
        <Route exact path="/place-kiosk" component={PlaceKiosk} />
        <Route exact path="/buy-kiosk" component={BuyKiosk} />
        <Route exact path="/bundles" component={Bundles} />
        <PrivateRoute exact path="/my-bundles" component={MyBundles} />
        <Route exact path="/join" component={Join} />
        <Route exact path="/stories" component={Stories} />
        <Route component={NotFound}></Route>
      </Switch>
    </Suspense>
  );
};

export default Routes;
